document.addEventListener('DOMContentLoaded', function() {
  // Only run on home page
  if (window.location.pathname !== '/') return;
  
  const stickyShopNow = document.querySelector('.sticky-shop-now');
  
  if (stickyShopNow) {
    // Show after scrolling 5% of page
    let scrollPercentage = 5;

    window.addEventListener('scroll', function() {
      // Calculate scroll position
      const scrollPosition = window.scrollY;
      const pageHeight = document.body.scrollHeight - window.innerHeight;
      const hasScrolledPastThreshold = (scrollPosition / pageHeight) * 100 > scrollPercentage;
      
      if (hasScrolledPastThreshold) {
        stickyShopNow.classList.add('is-visible');
      } else {
        stickyShopNow.classList.remove('is-visible');
      }
    });
  }
});